import { TOGGLE_NIVEAU_FILTER_MENU } from './constants';

export function toggleNiveauFilterMenu(value) {
  return {
    type: TOGGLE_NIVEAU_FILTER_MENU,
    value,
  };
}
